import { NavLink } from "react-router-dom";
// import LazyLoad from 'react-lazyload';
import { useEffect, useState } from "react";
import { RenderHtml3 } from "../components/renderhtml";
import { useModal } from "../components/usemodal";
import { PortfolioImg } from "../components/showbigimg";

export function CoursePageListContentPh(props) {
  let { showcourse, setTrangle, trangle, content, showtips, setSaveTips } =
    props;
  let currentShowCourse = showcourse.find((i) => i.id === trangle) || {};
  const [index, setIndex] = useState();
  const [workist, setWorkist] = useState([]);
  const { show, hide, RenderModal } = useModal();
  useEffect(() => {
    if (!content[0].student_works) return;
    else {
      setWorkist(content[0].student_works.sort((a, b) => b.sort - a.sort));
    }
  }, [content]);
  // useEffect(() => {
  //   let domtxt = document.querySelector('.ExpandDiv')
  //   if (!(domtxt)) return
  //   let num = domtxt.offsetHeight
  //   if (num === 0 || isNaN(num)) {
  //     setIsExpand(0)
  //     return;
  //   }
  //   if (num <= 200) {
  //     setIsExpand(3)
  //   } else {
  //     setIsExpand(1)
  //   }
  // }, [trangle, showcourse])

  let titleJson = {
    courseDescription: {
      title: "1.课程介绍",
      description: "COURSE,INTRODUCTION",
      component: (props) => {
        return (
          <div style={{ height: props.HTMLDATA ? "auto" : "0" }}>
            <pre
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
                overflow: "hidden",
              }}
            >
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: parseStr(props.HTMLDATA) }}
              ></div>
            </pre>
          </div>
        );
      },
    },
    courseTable: {
      title: "2.课程表",
      description: "CLASS,SCHEDULE,CARD",
      component: (props) => {
        return (
          <div>
            <pre
              className={"ExpandDiv"}
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "30px",
                overflow: "hidden",
              }}
            >
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: parseStr(props.HTMLDATA) }}
              ></div>
            </pre>
          </div>
        );
      },
    },
    // style={{ height: isExpand === 1 ? '200px' : isExpand === 2 ? 'auto' : isExpand === 0 ? '0px' : '', overflow: 'hidden' }}
    needDevice: {
      title: "3.需要的设备",
      description: "EQUIPMENT,NEEDED",
      component: (props) => {
        return (
          <div>
            <pre
              className={"ExpandDiv"}
              style={{
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                lineHeight: "1.5",
                overflow: "hidden",
              }}
            >
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: parseStr(props.HTMLDATA) }}
              ></div>
            </pre>
          </div>
        );
      },
    },
    // studentWork: {
    //   title: "4.学生作品",
    //   description: "STUDENT,WORKS",
    //   component: props => {
    //     console.log(props.HTMLDATA)
    //     let sendstuwork = JSON.parse(props.HTMLDATA).reduce((prev, next) => {
    //       prev.push(next.url)
    //       return prev
    //     }, [])
    //     return <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
    //       {/* {props.HTMLDATA && JSON.parse(props.HTMLDATA).map(i => (
    //         <img key={i.smallPicture} className="img-ajust-ph" alt="jiazaiz" src={i.smallPicture} width="100%" height="100%" style={{ objectFit: 'cover' }} onClick={() => {
    //           show()
    //           setIndex(i.url)
    //         }} />
    //       ))} */}
    //       {show && props.HTMLDATA && <RenderModal><PortfolioImg hide={hide} change={sendstuwork} index={sendstuwork.findIndex(i => i === index)} /></RenderModal>}
    //     </div>
    //   }
    // },
  };
  return (
    <div className="course-detail-ph">
      <div className="course-detail2-ph">
        <div className="course-info-commend-box">
          <div className="serise-box-title-ph">
            {showcourse.map((i, index) => {
              return (
                <div
                  key={i.id}
                  className={i.id === trangle ? "trangle-active" : ""}
                  onClick={() => {
                    setTrangle(i.id);
                  }}
                >
                  {i.coursePriodsName}
                </div>
              );
            })}
          </div>
          <div className="serise-box-content-ph">
            {showcourse.map((i, index) => {
              return (
                <div
                  key={i.id}
                  style={{ display: `${i.id === trangle ? "block" : "none"}` }}
                >
                  <RenderHtml3
                    flow={"100%"}
                    state={{ content: parseStr(i.basic) }}
                  />
                </div>
              );
            })}
          </div>
          <div className="serise-box-footer-ph">
            {showcourse.map((i) => {
              return (
                <div
                  key={i.id}
                  style={{ display: `${i.id === trangle ? "block" : "none"}` }}
                >
                  {i.type === 0 && i.target === "" ? (
                    <div className="buttontextstyleph">{i.buttonText}</div>
                  ) : i.type === 1 && i.buttonText !== "" ? (
                    <div
                      className="course-join-btnph"
                      onClick={() => {
                        showtips();
                        setSaveTips(i.modalContent);
                      }}
                    >
                      <span>{i.buttonText}</span>
                    </div>
                  ) : i.buttonText !== "" ? (
                    <div className="course-join-btnph">
                      <a href={i.target} rel="noreferrer" target="_blank">
                        {i.buttonText}
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
            <NavLink
              className="course-common-problemph"
              to="/commonproblem/seid/0"
            >
              <span>课程常见问题</span>
              <span>》》</span>
            </NavLink>
          </div>
        </div>
      </div>
      <div className="course-detail1-ph">
        {Object.keys(currentShowCourse).map((i) => {
          if (!titleJson[i]) return null;
          let Component = titleJson[i].component;
          let arrSpan = titleJson[i].description.split(",");
          return (
            <div key={i} className="course-content-ph">
              <div className="course-introduction-title-ph-box">
                <div>
                  <span>{titleJson[i].title}</span>
                </div>
                <div>
                  {arrSpan.map((j) => (
                    <span key={j}>{j}</span>
                  ))}
                </div>
              </div>
              <div className="rendertxt">
                {Component ? (
                  <Component
                    HTMLDATA={currentShowCourse[i]}
                    content={content}
                  />
                ) : (
                  <RenderHtml3
                    flow={7 + "rem"}
                    state={{ content: parseStr(currentShowCourse[i]) }}
                  />
                )}
              </div>
              {/* {i === 'courseTable' && isExpand !== 0 && <div>{
              isExpand === 1 ? <div onClick={() => { setIsExpand(2) }} className="click-box" ><span className="expand-icon-down"></span>
                <span className="text-lookmore-ph">查看更多</span></div> : isExpand === 2 ? <div className="click-box" onClick={() => { setIsExpand(1) }} style={{ cursor: 'pointer' }}><span className="expand-icon-up"></span><span className="text-lookup-ph">收起</span></div> : ''}</div>} */}
            </div>
          );
        })}
        <div
          className="course-content-ph"
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          <div className="course-introduction-title-ph-box">
            <div>
              <span>4.学生作品</span>
            </div>
            <div>STUDENT WORKS</div>
          </div>
          <div className="rendertxt">
            {workist &&
              workist.map((i) => (
                <img
                  key={i.id}
                  className="img-ajust-ph"
                  alt="jiazaiz"
                  src={i.smallPicture}
                  width="100%"
                  height="100%"
                  style={{ objectFit: "cover" }}
                  onClick={() => {
                    show();
                    setIndex(i.url);
                  }}
                />
              ))}
            {show && content && (
              <RenderModal>
                <PortfolioImg
                  hide={hide}
                  change={workist.reduce((prev, next) => {
                    prev.push(next.url);
                    return prev;
                  }, [])}
                  index={workist
                    .reduce((prev, next) => {
                      prev.push(next.url);
                      return prev;
                    }, [])
                    .findIndex((i) => i === index)}
                />
              </RenderModal>
            )}
          </div>
          {/* {props.HTMLDATA && JSON.parse(props.HTMLDATA).map(i => (
            <img key={i.smallPicture} className="img-ajust-ph" alt="jiazaiz" src={i.smallPicture} width="100%" height="100%" style={{ objectFit: 'cover' }} onClick={() => {
              show()
              setIndex(i.url)
            }} />
          ))} */}
        </div>
      </div>
      <div className="course-notes">
        <div className="note-box">
          <div className="note-icon1"></div>
          <div>
            <span>通过 直播云 授课平台进行直播授课，支持全平台设备</span>
          </div>
        </div>
        <div className="note-box">
          <div className="note-icon2"></div>
          <div>
            <span>直播课程结束后30分钟内即可观看课程回放</span>
          </div>
        </div>
        <div className="note-box">
          <div className="note-icon3"></div>
          <div>
            <span>
              科学合理的作业步骤安排，作业难度丝滑递进，可以直观看到自己的进步
            </span>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export function parseStr(str = "") {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, "")) / 1.7);
    return `font-size:${newValue}`;
  });
}
